import { createSelector, OutputSelector } from 'reselect'
import { IShipmentsCountState } from 'types'

interface IStore {
  shipmentsCount: IShipmentsCountState
}

const selectShipmentsCount = (state: {
  shipmentsCount: IShipmentsCountState
}): IShipmentsCountState => state.shipmentsCount

interface SelectShipmentTabsCount
  extends OutputSelector<
    IStore,
    {
      shipmentsCount: number[]
    },
    (
      res: IShipmentsCountState
    ) => {
      shipmentsCount: number[]
    }
  > {}

export const shipmentTabsCountSelector: SelectShipmentTabsCount = createSelector(
  selectShipmentsCount,
  ({ shipmentsCount }) => {
    if (Array.isArray(shipmentsCount) && shipmentsCount.length > 0) {
      return { shipmentsCount }
    }
    return { shipmentsCount: [] }
  }
)
